import {
  Box,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material";
import StewartCheckbox from "controls/global/stewart-checkbox";
import React from "react";
import {
  colors,
  fontSize,
} from "theme/defaultStyle";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import { PERMISSIONS, PageType } from "utils/data/enum";

interface Props<T> {
  handleCheckboxChange: (
    name: keyof T,
    value: any,
    execSearch: boolean,
  ) => void;
  handleCPLCheckboxChange: (
    name: keyof T,
    value: any,
    execSearch: boolean,
  ) => void;
  checked: boolean,
  disabled?: boolean;
  page? :PageType,
  cplChecked: boolean,
}

const StyledBox = styled(Box)({
  alignItems: "center",
  display: "flex",
  height: "100%",
});

const Label = styled(Typography)({
  color: colors.grey08,
  fontSize: fontSize.large,
});

const OpenCheckbox = <T extends object>({ handleCheckboxChange, checked,handleCPLCheckboxChange,cplChecked, disabled,page, ...rest }: Props<T>) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    handleCheckboxChange("userFilter" as keyof T, isChecked ? 1 : 0, true);
  };

  const handleCplCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const cplChecked = event.target.checked;
    handleCPLCheckboxChange("isCplOnlyFile" as keyof T, cplChecked ? 1 : 0, true);
  };

  const [{ profileSettings },] =
  useProfileSettingsCache();
  const permissionCodes = (profileSettings?.userPermissionItemTypes as string[]);
  
  return (
    <StyledBox {...rest}>
      <StewartCheckbox
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
        style={{ marginLeft: "-5px" }}
      />
      <Label>{page === PageType.ImageArchive ? "Only show images I've uploaded" : "Only show files I've opened"}</Label>

      {page === PageType.ReportPayPage && (permissionCodes?.includes(PERMISSIONS.CPL_REPORT_ONLY)) && (
        <>
          <StewartCheckbox
            disabled={disabled}
            checked={cplChecked}
            onChange={handleCplCheckboxChange}
            style={{ marginLeft: "-5px" }}
          />
          <Label>Show Files with CPLs only </Label>
        </>
      )}
    </StyledBox>
  );
};

export default OpenCheckbox;
